import { useNavigate, useRouteLoaderData } from "react-router";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { AlertCircle } from "lucide-react";
import {
	WORKSPACE_LOADER_ID,
	type WorkspaceLoaderData,
} from "@/routes/workspaceLoader";

export function ErrorLogButton() {
	const navigate = useNavigate();
	const layoutData = useRouteLoaderData(WORKSPACE_LOADER_ID) as
		| WorkspaceLoaderData
		| undefined;
	const unresolvedCount = layoutData?.errorLogsUnresolvedCount ?? 0;

	return (
		<Button
			variant="ghost"
			size="sm"
			onClick={() => navigate("/error-logs")}
			className="relative"
			title="View Error Logs"
			aria-label={
				unresolvedCount > 0
					? `View Error Logs (${unresolvedCount} unresolved)`
					: "View Error Logs"
			}
		>
			<AlertCircle className="h-5 w-5" />
			{unresolvedCount > 0 && (
				<Badge
					variant="destructive"
					className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center p-0 text-xs"
				>
					{unresolvedCount > 99 ? "99+" : unresolvedCount}
				</Badge>
			)}
		</Button>
	);
}
